import React from 'react';
import './SolutionsAndChallenges.css';

const SolutionsAndChallenges = React.forwardRef(function SolutionsAndChallenges(props, ref) {
  return (
    <section
      ref={ref}
      id="solutions-and-challenges"
      className="solutions-challenges-section"
    >
      <div className="solutions-challenges-container">
        <img
          src="/challenges&solutions.svg"
          alt="Challenges and Solutions illustration"
          className="solutions-challenges-image"
          loading="lazy"
        />
      </div>
    </section>
  );
});

export default SolutionsAndChallenges;